/**
 * @generated SignedSource<<d3bdad0edff1ea3700ff01d5550d3e49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type auth_useAuthGate$data = {
  readonly " $fragmentSpreads": FragmentRefs<"auth_useRedirectPath">;
  readonly " $fragmentType": "auth_useAuthGate";
};
export type auth_useAuthGate$key = {
  readonly " $data"?: auth_useAuthGate$data;
  readonly " $fragmentSpreads": FragmentRefs<"auth_useAuthGate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "auth_useAuthGate",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "auth_useRedirectPath"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "55d23a1bb006249d78199a90cea89fef";

export default node;
